import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiBreadcrumbComponent {

    @HostBinding() class = 'eui-breadcrumb';

    constructor(

    ) {}

}
